import { Injectable } from '@angular/core';
import { PagoDTO } from 'src/app/pago/dtos/PagoDTO';
import { Pago } from 'src/app/pago/models/Pago.model';

@Injectable({
  providedIn: 'root',
})
export class PagoFactory {
  convertToModel(pagoDTO: PagoDTO): Pago {
    return {
      idPago: pagoDTO.idPago,
      renovacionAutomatica: pagoDTO.renovacionAutomatica,
      ...pagoDTO.pago,
    };
  }

  convertToDto(pago: Pago): PagoDTO {
    return {
      idPago: pago.idPago,
      renovacionAutomatica: pago.renovacionAutomatica,
      pago: {
        medioPago: pago.medioPago,
        tarjetaCredito: pago.tarjetaCredito,
        descuentosAplicados: pago.descuentosAplicados,
        estadoPago: pago.estadoPago,
        subTotal: pago.subTotal,
        total: pago.total,
        totalDescuentos: pago.totalDescuentos,
      },
      nombreProducto: pago.nombreProducto,
      ...(pago.pagador ? { pagador: { ...pago.pagador } } : {}),
    };
  }
}
